import { atom } from "jotai";

export const publicacionesAtom = atom([]);
export const publicacionesFijasAtom = atom([]);
export const totalPublicacionesAtom = atom(0);
export const paginaAtom = atom(0);
export const comentariosAtom = atom([]);
export const paginaComentarioAtom = atom(0);
export const totalComentariosAtom = atom(0);